"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _client = require("@apollo/client");
var _utils = require("../utils");
const defaultOptions = {
  watchQuery: {
    fetchPolicy: "network-only",
    errorPolicy: "ignore"
  },
  query: {
    fetchPolicy: "network-only",
    errorPolicy: "all"
  }
};
const cache = new _client.InMemoryCache({
  addTypename: false
});
var _default = exports.default = function _default(uri) {
  let options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  const authMiddleware = new _client.ApolloLink((operation, forward) => {
    const headers = {
      LoggerTraceId: (options.appName || "EL") + "-" + new _utils.IDGenerator().generate()
    };
    if (options.appName === "SupplierNet PO") {
      // headers.AuthRoleToken = localStorage.getItem("rdsAppToken");
      headers.JWTTKNCKEY = localStorage.getItem("jwttknkey");
    }
    operation.setContext({
      headers: headers
    });
    return forward(operation);
  });
  return new _client.ApolloClient({
    link: (0, _client.concat)(authMiddleware, new _client.HttpLink({
      uri
    })),
    fetchOptions: {
      mode: "no-cors"
    },
    cache,
    defaultOptions
  });
};